import { useState, useRef, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import companyLogowithoutbg from '../assets/jpg/companyLogoWithoutbg.png'
import './Navbar.css'
import { getAuth, onAuthStateChanged } from 'firebase/auth'

function Navbar() {
  const navigate = useNavigate()
  const location = useLocation()
  const auth = getAuth()
  const [showProfile, setShowProfile] = useState(false)

  const isMounted = useRef(true)

  useEffect(() => {
    if (isMounted) {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          setShowProfile(true)
        } else {
          setShowProfile(false)
        }
        return () => {
          isMounted.current = false
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMounted])

  const pathMatchRoute = (route) => {
    if (route === location.pathname) {
      return true
    }
  }

  return (
    <header className="navbar">
      <nav className="navbarNav">
        <div className="brand">
          <img
            className="companyLogo"
            src={companyLogowithoutbg}
            alt=""
            onClick={() => navigate('/')}
          />
        </div>
        <ul className="navbarListItems">
          <li className="navbarListItem" onClick={() => navigate('/')}>
            <p
              className={
                pathMatchRoute('/')
                  ? 'navbarListItemNameActive'
                  : 'navbarListItemName'
              }
            >
              Explore
            </p>
          </li>
          <li className="navbarListItem" onClick={() => navigate('/offers')}>
            <p
              className={
                pathMatchRoute('/offers')
                  ? 'navbarListItemNameActive'
                  : 'navbarListItemName'
              }
            >
              Offers
            </p>
          </li>
          {showProfile && (
            <li className="navbarListItem" onClick={() => navigate('/profile')}>
              <p
                className={
                  pathMatchRoute('/profile')
                    ? 'navbarListItemNameActive'
                    : 'navbarListItemName'
                }
              >
                Profile
              </p>
            </li>
          )}
        </ul>
      </nav>
    </header>
  )
}

export default Navbar
